/*

FILE: main.js
DESCRIPTION: Entry point
AUTHOR(S): Nick Katarow

*/
import lazySizes from 'lazysizes';
import { setElementRefs, elements } from './_components/elements.js';
import { state, setState } from './_components/state.js';
import { updateVideoSource, gaussianBlurImage } from './_components/utils.js';
import { setEventHandlers } from './_components/app-events.js';
import initScrollWaypoints from './_components/scroll.js';
import initStickyPanels from './_components/sticky-panels.js';
import initAppPreview from './_components/app-preview.js';
import typingEffect from './_components/hero.js';

// Set element and state values
const initState = (context) => {
    setElementRefs(context);
    setEventHandlers();
    setState();
};

// Init page-level modules
const initModules = () => {
    if (elements.animateIn.length) initScrollWaypoints(elements.animateIn);
    if (elements.stickyPanelContainer) initStickyPanels(elements.stickyPanelContainer);
    if (elements.gaussianBlur.length) gaussianBlurImage(elements.gaussianBlur);
    if (elements.stackedImages.length) updateVideoSource(elements.stackedImages, state.breakpoint);
    if (elements.appPreview.length) initAppPreview(elements.appPreview);
    if (elements.typingEffect) typingEffect(elements.typingEffect);
};

// // Main init on load
document.documentElement.classList.remove('no-js');

lazySizes.cfg.preloadAfterLoad = true;

initState();
initModules();
